import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { PAYMENT_TYPE } from '../constants';

interface PaymentMethodDialogProps {
  open: boolean;
  onClose: (confirmed: boolean, paymentMethod?: number) => void;
  defaultPaymentMethod?: number;
}

const PaymentMethodDialog: React.FC<PaymentMethodDialogProps> = ({
  open,
  onClose,
  defaultPaymentMethod = PAYMENT_TYPE.CASH,
}) => {
  const { t } = useTranslation();
  const [selectedMethod, setSelectedMethod] = React.useState<number>(defaultPaymentMethod);

  // React.useEffect(() => {
  //   if (defaultPaymentMethod !== undefined) {
  //     setSelectedMethod(defaultPaymentMethod);
  //   }
  // }, [defaultPaymentMethod]);

  const handleConfirm = () => {
    onClose(true, selectedMethod);
  };

  const handleCancel = () => {
    onClose(false);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t("selectPaymentMethod")}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t("selectPaymentMethodDesc")}
        </DialogContentText>
        <Box sx={{ px: 2 }}>
          <RadioGroup
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(Number(e.target.value))}
          >
            <FormControlLabel
              value={PAYMENT_TYPE.CASH}
              control={<Radio />}
              label={t("cash")}
            />
            <FormControlLabel
              value={PAYMENT_TYPE.CREDIT_CARD}
              control={<Radio />}
              label={t("creditCard")}
            />
            <FormControlLabel
              value={PAYMENT_TYPE.ZELLE}
              control={<Radio />}
              label={t("ZELLE")}
            />
            <FormControlLabel
              value={PAYMENT_TYPE.VENMO}
              control={<Radio />}
              label={t("VENMO")}
            />
            <FormControlLabel
              value={PAYMENT_TYPE.CHECK}
              control={<Radio />}
              label={t("labelCheck")}
            />
            <FormControlLabel
              value={PAYMENT_TYPE.ACCOUNT_BILLING}
              control={<Radio />}
              label={t("accountBilling")}
            />
          </RadioGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t("btnCancel")}
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentMethodDialog;